(function () {
    'use strict';

    function main() {
        var modal = wo$('#call-back-modal');
        if (!modal.length) return;
        var modalData = WhistleOut.readLookupData(modal);
        var data;

        var callbackModalController = {
            init: function () {
                modal.on('show.bs.modal', function (e) {
                    data = WhistleOut.readLookupData(wo$(e.relatedTarget).parent());
                    modal.find('[data-gateway-heading]').text(data.heading);
                    modal.find('[data-gateway-sub-heading]').text(data.subHeading);
                    modal.find('[data-gateway-product-heading]').text(data.productHeading);
                    modal.find('[data-original-supplier-name]').text(data.originalSupplierName);
                    modal.find('[data-supplier-image]').attr('src', data.supplierImageUrl);
                    modal.find('[data-supplier-image]').attr('alt', data.supplierName);
                    if (data.hasDevice === true && data.deviceImageUrl && data.deviceImageUrl.length > 0) {
                        modal.find('[data-device-image]').attr('src', data.deviceImageUrl);
                        modal.find('[data-device-image]').attr('alt', data.productName);
                        modal.find('[data-device-image]').show();
                    } else {
                        modal.find('[data-device-image]').hide();
                    }
                    modal.find('[data-product-name]').text(data.productName);
                    modal.find('[data-price-whole]').text(data.priceWhole);
                    if (!data.priceWhole) {
                        modal.find('[data-price-currency-symbol]').text('');
                    }

                    modal.find('[data-price-decimal-and-frequency]').text(data.paymentFrequency);
                    if (data.showMinTotalCost) {
                        modal.find('[data-min-total-cost]').text(data.minTotalCost);
                        modal.find('[data-min-total-cost]').show();
                    } else {
                        modal.find('[data-min-total-cost]').hide();
                    }

                    if (data.hideCallbackTime) {
                        modal.find('[data-callback-time]').hide();
                    } else {
                        modal.find('[data-callback-time]').show();
                    }
                    modal.find('[data-gateway-option-1]').text(data.option1Text);
                    if (data.hideOption2) {
                        modal.find('[data-option-2]').hide();
                    } else {
                        modal.find('[data-gateway-option-2]').text(data.option2Text);
                        modal.find('[data-option-2]').show();
                    }

                    if (!data.optInText || data.optInText === '') {
                        modal.find('[data-optin]').hide();
                        modal.find('[data-privacy]').show();
                    } else {
                        modal.find('[data-optin]').show();
                        modal.find('#optin-label').html(data.optInText);
                        modal.find('[data-privacy]').hide();
                    }
                });

                modal.on('shown.bs.modal', function () {
                    modal.find('#fname').focus();
                });

                modal.on('hide.bs.modal', function () {
                    callbackModalController.clearError();
                    modal.find('#fname').val('');
                    modal.find('#lname').val('');
                    modal.find('#phone').val('');
                    modal.find('#email').val('');
                    modal.find('#store').val(modal.find('#store option:first').val());
                    modal.find('#preferredtime').val(modal.find('#preferredtime option:first').val());
                    modal.find('#option1').prop('checked', false);
                    modal.find('#option2').prop('checked', false);
                    modal.find('#optin').prop('checked', false);

                    var defaultState = modal.data('default-state');
                    modal.find('#state').val(defaultState);

                    modal.find('[data-form-controls]').show();
                });

                modal.find('#callback-modal-submit').click(function () {
                    callbackModalController.clearError();

                    var invalid = false;
                    var firstName = modal.find('#fname').val();
                    if (firstName.trim() === '') {
                        invalid = true;
                        callbackModalController.showError('#fname');
                    }
                    var lastName = modal.find('#lname').val();
                    if (lastName.trim() === '') {
                        invalid = true;
                        callbackModalController.showError('#lname');
                    }
                    var phone = modal.find('#phone').val();
                    if (phone.trim() === '') {
                        invalid = true;
                        callbackModalController.showError('#phone');
                    } else if (!new RegExp(modal.find('#phone').data('validation-regex')).test(phone.trim())) {
                        invalid = true;
                        callbackModalController.showError('#phone', true);
                    }

                    var email = modal.find('#email').val();
                    if (email.trim() === '') {
                        invalid = true;
                        callbackModalController.showError('#email');
                    } else if (!new RegExp(modal.find('#email').data('validation-regex')).test(email.trim())) {
                        invalid = true;
                        callbackModalController.showError('#email', true);
                    }

                    var storeList = modal.find('#store');
                    var store = storeList.val();

                    var stateList = modal.find('#state');
                    var state = stateList.val();
                    if (stateList.length > 0 && state.trim() === '') {
                        invalid = true;
                        callbackModalController.showError('#state');
                    }

                    if (modal.find('[data-optin]').is(':visible') && !modal.find('#optin').is(':checked')) {
                        invalid = true;
                        callbackModalController.showError('#optin');
                    }

                    if (!invalid) {
                        callbackModalController.clearError();

                        modal.find('button[name="modal-submit"]').attr('disabled', 'disabled');
                        modal.find('span[name="modal-submit-spinner"]').show();

                        var callbackData = {
                            gatewayId: data.gatewayId,
                            productId: data.productId,
                            deviceId: data.deviceId,
                            firstName: firstName,
                            lastName: lastName,
                            phone: phone,
                            email: email,
                            state: state,
                            storeId: store,
                            time: modal.find('#preferredtime').val(),
                            option1: modal.find('#option1').is(':checked'),
                            option2: modal.find('#option2').is(':checked'),
                            productUrl: window.restoreDeferredQuery(data.productUrl)
                        };

                        wo$.ajax({
                            url: modal.data('url'),
                            type: 'POST',
                            data: callbackData,
                            dataType: 'json',
                            success: function (result) {
                                switch (result) {
                                    case 2:
                                        callbackModalController.showSubmitError(modalData.alreadySubmitted);
                                        break;
                                    case 3:
                                        callbackModalController.showSubmitError(modalData.invalidPhoneNumber);
                                        break;
                                    default:
                                        modal.find('[data-form-controls]').hide();
                                        WhistleOut.trackEvent('CallbackPopup', 'Submit', data.supplierId);
                                        modal.find('[data-submit-success]').show();
                                        modal.find('button[name="modal-submit"]').attr('disabled', 'disabled');
                                        modal.find('span[name="modal-submit-spinner"]').hide();
                                        setTimeout(function () {
                                            modal.modal('hide');
                                        }, 5000);
                                        break;
                                }
                            },
                            error: function () {
                                callbackModalController.showSubmitError(modalData.genericError);
                            }
                        });
                    }
                });
            },

            showError: function (inputSelector, isInvalidValidation) {
                modal.find(inputSelector).parent().addClass('has-error');
                if (isInvalidValidation === true) {
                    modal.find(inputSelector).siblings('[data-validation-error-invalid]').show();
                } else {
                    modal.find(inputSelector).siblings('[data-validation-error]').show();
                }
                modal.find('button[name="modal-submit"]').prop('disabled', false);
                modal.find('span[name="modal-submit-spinner"]').hide();
            },

            showSubmitError: function (error) {
                modal.find('[data-submit-error]').html(error);
                modal.find('[data-submit-error]').show();
                modal.find('button[name="modal-submit"]').prop('disabled', false);
                modal.find('span[name="modal-submit-spinner"]').hide();
            },

            clearError: function () {
                modal.find('.form-group').removeClass('has-error');
                modal.find('[data-validation-error]').hide();
                modal.find('[data-validation-error-invalid]').hide();
                modal.find('[data-submit-error]').hide();
                modal.find('[data-submit-success]').hide();
                modal.find('button[name="modal-submit"]').prop('disabled', false);
                modal.find('span[name="modal-submit-spinner"]').hide();
            }
        };

        callbackModalController.init();
    }

    WhistleOut.initModule(import.meta.url, main);
})();
